module.exports = __webpack_public_path__ + "img/car_toy.be5030ca.webp";